let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ghRDy")).then(() => parcelRequire('377EB'));